<template>
  <v-snackbar v-model="show"
              :color="color"
              :timeout="timeout"
              :multi-line="$vuetify.breakpoint.smAndDown">
    {{ message }}
    <v-btn icon
           flat
           @click="show = false">
      <v-icon>close</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    show: {
      get () {
        return this.$store.state.notifications.show
      },
      set (show) {
        this.$store.commit('notifications/setShow', show)
      }
    },
    ...mapState({
      color: state => state.notifications.color,
      message: state => state.notifications.message,
      timeout: state => state.notifications.timeout
    })
  }
}
</script>
